import { useTypedParams } from '@sorare/routing';

import type { PageParams } from './__generated__/routeParams';

const SeriesTaskLineupsPage = () => {
  const { task } = useTypedParams<PageParams>();

  return <div>SeriesTaskLineupsPage : {task}</div>;
};
export default SeriesTaskLineupsPage;
